import { EmptyContent } from "@/common";
import { crudGetList, useList } from "@/legacy/redux";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "jsondiffpatch/dist/formatters-styles/html.css";
import { Skeleton } from "@mui/material";
import { CurrentChange } from "./CurrentChange";
import { ChangeHistoryTimeline } from "./Timeline";

type ChangeHistoryModalCoreProps = {
  changes: any;
  setCurrentChange: (v: unknown) => unknown;
  currentChange: any;
  pagination: { page: number; perPage: number };
  count: number;
  setCurrentPage: (num: number) => unknown;
};
const ChangeHistoryModalCore: React.FC<ChangeHistoryModalCoreProps> = (p) => {
  const { changes, currentChange, setCurrentChange, pagination, count, setCurrentPage } = p;

  return (
    <>
      <ChangeHistoryTimeline
        changes={changes}
        setCurrentChange={setCurrentChange}
        pagination={pagination}
        count={count}
        setCurrentPage={setCurrentPage}
      />
      <CurrentChange currentChange={currentChange} />
    </>
  );
};

const ChangeHistoryModal = ({ release }) => {
  const dispatch = useDispatch();

  // ===================================================================================

  const [pagination, setPagination] = React.useState({ page: 1, perPage: 10 });
  const paginationRef = React.useRef(pagination);
  if (paginationRef.current !== pagination) paginationRef.current = pagination;

  const loadChanges = React.useCallback(
    (nextPagination?: typeof pagination) => {
      if (!release) return;

      dispatch(
        crudGetList("releases", "changes", {
          subResource: "changes",
          componentId: release.id,
          pagination: nextPagination || paginationRef.current,
        }),
      );
    },
    [release],
  );

  useEffect(() => {
    loadChanges();
  }, [release, loadChanges]);

  const setCurrentPage: ChangeHistoryModalCoreProps["setCurrentPage"] = React.useCallback(
    (page) => {
      const nextPagination: typeof pagination = { ...paginationRef.current, page };
      setPagination(nextPagination);
      loadChanges(nextPagination);
    },
    [setPagination, loadChanges],
  );

  // ===================================================================================

  // @ts-ignore
  const changes = useList("changes", "changes", release?.id, { pagination });
  const count = changes?.total || 0;

  const [currentChange, setCurrentChange] = useState();

  if (!release) return null;

  return (
    <div className="flex h-full gap-2 overflow-auto">
      {(() => {
        if (!changes || changes.isLoading || !changes.loadedOnce) {
          return (
            <>
              <div className="w-full sm:w-3/12">
                {Array(5)
                  .fill(0)
                  .map((_, i) => (
                    <Skeleton
                      key={i}
                      variant="rectangular"
                      height={67}
                      style={{ marginBottom: 8 }}
                    />
                  ))}
              </div>
              <div className="w-full sm:w-9/12">
                <Skeleton
                  variant="rectangular"
                  width="60%"
                  height={300}
                  style={{ marginBottom: 10 }}
                />
              </div>
            </>
          );
        }
        if (changes && changes.total === 0) {
          return (
            <EmptyContent
              variant="h4"
              messages={["No change history recorded."]}
            />
          );
        }

        return (
          <ChangeHistoryModalCore
            changes={changes}
            currentChange={currentChange}
            // @ts-ignore
            setCurrentChange={setCurrentChange}
            pagination={pagination}
            count={count}
            setCurrentPage={setCurrentPage}
          />
        );
      })()}
    </div>
  );
};
export default ChangeHistoryModal;
